import { cn } from '@/utils/cn'
import * as CheckboxPrimitive from '@radix-ui/react-checkbox'
import { type ComponentPropsWithoutRef, type ElementRef, forwardRef } from 'react'
import { CheckIcon } from '../icons/check'

export const Checkbox = forwardRef<
  ElementRef<typeof CheckboxPrimitive.Root>,
  ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>
>(({ className, ...props }, ref) => (
  <CheckboxPrimitive.Root
    ref={ref}
    className={cn(
      'peer flex size-5 shrink-0 rounded-md border border-border-strong bg-input text-button-foreground outline-none transition-colors',
      'hocus:bg-input-hover',
      'hover:border-body-foreground',
      'focus-visible:border-focus focus-visible:ring-2',
      'data-[state=checked]:border-accent data-[state=checked]:bg-accent',
      'data-[state=checked]:[&:not(:disabled)]:hocus:border-accent-hover data-[state=checked]:[&:not(:disabled)]:hocus:bg-accent-hover',
      'data-[state=checked]:disabled:border-input-disabled data-[state=checked]:disabled:bg-input-disabled data-[state=checked]:disabled:text-disabled-foreground',
      'disabled:border-border-strong disabled:bg-input-disabled',
      className
    )}
    {...props}
  >
    <CheckboxPrimitive.Indicator className={cn('flex h-full w-full items-center justify-center text-current')}>
      <CheckIcon size={16} />
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
))
Checkbox.displayName = CheckboxPrimitive.Root.displayName
